import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type ResourceId = Branded<string, "ResourceId">;
const resourceIdPrefix = "resource__";
const {
    zodSchema: resourceIdZodSchema,
    factory: resourceIdFactory,
    assert: isResourceId,
} = genericId<ResourceId>(resourceIdPrefix, {
    regexMatch: /(^resource_(?!foundation_|graph_|reservation_).*$)/,
    // TODO! THIS IS TO GENERIC :(
    // Improved it to not catch resource_foundation_ ids
    // Improved it to not catch resource_graph_ ids
    // Improved it to not catch resource_reservation_ ids
});

export {
    isResourceId,
    resourceIdFactory,
    resourceIdPrefix,
    resourceIdZodSchema,
};
export type { ResourceId };
